import React from 'react';
import { Box, Button, IconButton, Stack, Tooltip, Typography } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

/**
 * Right column of the inbox — selected message detail and the Reply /
 * Archive / Delete actions.
 *
 * Reply is a `mailto:` link (not an in-app composer) so brand owners
 * keep their thread in their normal email client, where it'll show up
 * later under "Sent" and they can keep replying to it.
 */
export default function InboxReader({ message, onArchive, onDelete }) {
  return (
    <Box
      sx={{
        flex: 1, p: '18px',
        display: { xs: message ? 'block' : 'none', md: 'block' },
      }}
    >
      {!message ? (
        <Typography variant='body2' color='text.secondary'>
          Select a message to read it here.
        </Typography>
      ) : (
        <Stack spacing='10px'>
          <Box>
            <Typography variant='caption' color='text.secondary' textTransform='uppercase' fontWeight='700' display='block' mb='2px'>
              From
            </Typography>
            <Typography>
              {message.name} &lt;
              <a href={`mailto:${message.email}`} style={{ color: '#3182ce' }}>
                {message.email}
              </a>
              &gt;
            </Typography>
            <Typography variant='caption' color='text.secondary' mt='2px' display='block'>
              {new Date(message.createdAt).toLocaleString()}
            </Typography>
          </Box>
          {message.subject && (
            <Box>
              <Typography variant='caption' color='text.secondary' textTransform='uppercase' fontWeight='700' display='block' mb='2px'>
                Subject
              </Typography>
              <Typography fontWeight='600'>{message.subject}</Typography>
            </Box>
          )}
          <Box>
            <Typography variant='caption' color='text.secondary' textTransform='uppercase' fontWeight='700' display='block' mb='2px'>
              Message
            </Typography>
            <Typography sx={{ whiteSpace: 'pre-wrap' }}>{message.body}</Typography>
          </Box>
          <Stack direction='row' spacing='8px' pt='10px' flexWrap='wrap'>
            <Button
              size='small' variant='contained'
              component='a'
              href={`mailto:${message.email}${message.subject ? `?subject=Re: ${encodeURIComponent(message.subject)}` : ''}`}
            >
              Reply
            </Button>
            {message.status !== 'archived' && (
              <Button size='small' variant='outlined' onClick={() => onArchive(message)}>
                Archive
              </Button>
            )}
            <Tooltip title='Delete'>
              <IconButton size='small' color='error' onClick={() => onDelete(message)}>
                <DeleteIcon fontSize='small' />
              </IconButton>
            </Tooltip>
          </Stack>
        </Stack>
      )}
    </Box>
  );
}
